import { render, staticRenderFns } from "./ReportAccidentCreate.vue?vue&type=template&id=0c44a4ba&scoped=true&"
import script from "./ReportAccidentCreate.vue?vue&type=script&lang=js&"
export * from "./ReportAccidentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c44a4ba",
  null
  
)

export default component.exports